<template>
  <div class="tw-flex tw-justify-start tw-text-gray-dark dark:tw-text-dm-gray-dark tw-gap-6 tw-px-6 tw-mb-3">
    <AdministrationTableHeaderColumn
      v-for="column in columns"
      :key="column.prop"
      :prop="column.prop"
      :title="column.title"
      :sorting-enabled="column.sortingEnabled"
      :style="`width: ${column.width}`"
      :store-path="storePath"
      :filters-state-relative-path="filtersStateRelativePath"
      :filters-mutation-relative-path="filtersMutationRelativePath"
      :need-to-translate-column-title="needToTranslateColumnTitle"
    />
  </div>
</template>

<script>

import AdministrationTableHeaderColumn
  from '@/components/Administration/components/AdministrationTableHeaderColumn.vue';

export default {
  name: 'AdministrationTableHeader',
  components: {
    AdministrationTableHeaderColumn,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    storePath: {
      type: String,
      required: true,
    },
    filtersStateRelativePath: {
      type: String,
      required: true,
    },
    filtersMutationRelativePath: {
      type: String,
      required: true,
    },
    needToTranslateColumnTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
